import { Tag , Typography } from "antd";
import { useIntl } from "react-intl";

import { PrioritySeverityLevel } from "../enums/PrioritySeverityLevel";
import { getPrimaryColor, getMessageKey } from "../helpers/severity-level";

interface IProps {
    value: number
    severityLevel: PrioritySeverityLevel
}

export const PrioritySeverityTag = ({ value, severityLevel }: IProps) => {
  const intl = useIntl();
  const primaryColor = getPrimaryColor(severityLevel);
  const messageKey = getMessageKey(severityLevel);
  return (
    <>
      <Typography.Text style={{ color: primaryColor }} strong>{value}</Typography.Text>
      &nbsp;
      <Tag color={primaryColor} style={{ color: 'white', fontWeight: 'bold' }}>
        {messageKey !== null && intl.formatMessage({ id: `risksAndIssues.severity.${messageKey}` })}
      </Tag>
    </>
  );
};